export { PurchasesView } from './PurchasesView';
